/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import Command from "./../../../Basis/Commands/Command";

export interface AendereEigeneFirmendatenInput {
    mandantId: string;
    geaendert: string;
    name1: string;
    name2?: string;
    name3?: string;
    strasse: string;
    postleitzahl: string;
    ort: string;
    region: string;
    land: string;
    eMail: string;
    mobil?: string;
    telefon?: string;
    fax?: string;
    umsatzsteuerIdNr?: string;
    steuernummer?: string
    hatRechnungsadresse: boolean;
    rechnungsadresseName1?: string;
    rechnungsadresseName2?: string;
    rechnungsadresseName3?: string;
    rechnungsadresseStrasse?: string;
    rechnungsadressePostleitzahl?: string;
    rechnungsadresseOrt?: string;
    rechnungsadresseRegion?: string;
    rechnungsadresseLand?: string;
    rechnungsadresseEMail?: string;
    rechnungsadresseMobil?: string;
    rechnungsadresseTelefon?: string;
    rechnungsadresseFax?: string;
    rechnungsadresseUmsatzsteuerIdNr?: string;
    rechnungsadresseSteuernummer?: string;
    anzahlMitarbeitendeId?: string;
    schwerpunktId?: string;
    schwerpunktSonstiges?: string;
    zusatzangabe1?: string;
    zusatzangabe2?: string;
    zusatzangabe3?: string;
    bank?: string;
    iban?: string;
    bic?: string;
    homepage?: string;
    mandantBezeichnungAnpassen: boolean;
}

export default class AendereEigeneFirmendaten extends Command<void, AendereEigeneFirmendatenInput> {
    public static readonly commandName = "Mandanten_AendereEigeneFirmendaten";

    private static readonly mutation = gql`
        mutation ${AendereEigeneFirmendaten.commandName}($input: ${AendereEigeneFirmendaten.commandName}) {
            ${AendereEigeneFirmendaten.commandName}(input: $input)
        }
    `;

    public constructor(refetchQueries: string[] = []) {
        super(AendereEigeneFirmendaten.mutation, refetchQueries);
    }

    public get name(): string {
        return AendereEigeneFirmendaten.commandName;
    }
}
